export default function () {
  // reativando com do usuario e mostrando modal de bem vindo
  this.doActive()
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/resources/mounted.js